import { convertPrdToCimSku } from '../api';

export async function resolveProductSku(skuOrUrl: string, signal?: AbortSignal): Promise<string> {
    if (!skuOrUrl) return skuOrUrl;

    if (skuOrUrl.includes('://') || skuOrUrl.startsWith('PRD-')) {
        const cimSku = await convertPrdToCimSku(skuOrUrl, signal);
        if (cimSku) {
            return cimSku;
        }
    }

    return skuOrUrl;
}
